import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { formatAmount } from "utils/Utils";
const FoirConfig = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns] = useState([
    { id: "minLoanAmount", label: "Minimum Income (₹)" },
    { id: "maxLoanAmount", label: "Maximum Income (₹)" },
    { id: "foirPercentage", label: "FOIR (%)" },
    { id: "action", label: "Action" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteFoirId, setDeleteFoirId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FOIR_CONFIG_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  const parseIndicatorData = (data) => {
    let reportData = [];

    data?.forEach((item) => {
      reportData.push({
        minLoanAmount: formatAmount(item?.minLoanAmount),
        maxLoanAmount: formatAmount(item?.maxLoanAmount),
        foirPercentage: `${item?.foirPercentage}%`,
        action: getIcons(item?.id),
      });
    });

    setSelectedTableData(reportData);
  };
  const getIcons = (foir) => {
    return (
      <>
        <IconButton
          aria-label="Edit Foir"
          onClick={() => onClickUpdateData(foir)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Foir"
          onClick={() => onClickDeleteData(foir)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (id) => {
    navigate(`/coreservice/foirConfigCreate/${id}`);
  };
  // delete function
  const onClickDeleteData = (foir) => {
    setConfirmationModalHeader("FOIR Configuration");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteFoirId(foir);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteFoirId("");
  };
  const handlePositiveResponse = async () => {
    const foirid = deleteFoirId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Foir
    const res = await apiHandler({
      url: endpoint.FOIR_CONFIG_DELETE + foirid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "FOIR Configuration deleted successfully", true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const value = event.target.value?.toLowerCase();

    const filteredData = rawData.filter((row) => {
      return (
        String(row?.minLoanAmount)?.toLowerCase()?.includes(value) ||
        String(row?.maxLoanAmount)?.toLowerCase()?.includes(value) ||
        String(row?.foirPercentage)?.toLowerCase()?.includes(value)
      );
    });

    parseIndicatorData(filteredData);
  };
  const handleCreateFoir = () => {
    navigate(`/coreservice/foirConfigCreate`);
  };
  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <SubHeader
            label="FOIR Configuration"
            button1="Create"
            button1click={handleCreateFoir}
            onSearchChange={onSearchChange}
            searchLabel="Search FOIR Configuration"
            search
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <ColumnGroupingTable
            columns={tableColumns}
            rows={selectedTableData}
          />
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      </GridContainer>
    </>
  );
};

export default FoirConfig;
